<div class="container-fluid noPadding nomargin news-all" *ngIf="PdfDataList.length !==0">
  <br>
  <div aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item active"><a href="/">
          <img _ngcontent-qho-c122="" src="content/images/home-icon.svg" title="home-icon" class="img-fluid">Home</a>
      </li>


    </ol>
  </div>

  <div class='row offset-md-1'>
    <span class="heading col-lg-12 col-md-12 col-sm-12" cbicTranslate="menu.allNews"></span>

    <div *ngFor="let usefulLink of tickersList">

      <span *ngIf="flag === 'En'">

        <ul class="all-new-list">

          <li>
            <!--<span class="dot"></span>&nbsp;&nbsp;{{usefulLink.titleEn}}--->

            <span *ngFor="let pdflist of PdfDataList">

              <span
                *ngIf="usefulLink.id === pdflist.content?.id && pdflist.docTitleEn !== null && pdflist.filePathEn === null">

                {{pdflist.docTitleEn}}&nbsp;

              </span>

              <span
                *ngIf="usefulLink.id === pdflist.content?.id && pdflist.docTitleEn !== null && pdflist.filePathEn !== null">

                <a [routerLink]="" (click)="ViewPdf(pdflist.filePathEn)">

                  {{pdflist.docTitleEn}}&nbsp;<i *ngIf="pdflist.docType ==='pdf'" class="pdf-icon"
                    aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType ==='xls' || pdflist.docType ==='xlsx' || pdflist.docType ==='xlsb'"
                    class="xls-icon" aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType ==='link'" class="">click here</i> </a>

              </span>

            </span>

          </li>

        </ul>



      </span>

      <span *ngIf="flag === 'Hi'">

        <ul class="all-new-list">

          <li>
            <!-- *ngIf="usefulLink.titleHi!==null"<span class="dot"></span>&nbsp;&nbsp;{{usefulLink.titleHi}}--->

            <span *ngFor="let pdflist of PdfDataList">

              <span *ngIf="usefulLink.id === pdflist.content?.id  && pdflist.docTitleHi!=null">

                <a [routerLink]="" (click)="ViewPdf(pdflist.filePathHi)">

                  {{pdflist.docTitleHi}}&nbsp;<i *ngIf="pdflist.docType ==='pdf'" class="pdf-icon"
                    aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType ==='xls' || pdflist.docType ==='xlsx' || pdflist.docType ==='xlsb'"
                    class="xls-icon" aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType ==='link'" class="external-link" aria-hidden="true"></i> </a>

              </span>

              <span *ngIf="usefulLink.id === pdflist.content?.id &&  pdflist.docTitleHi===null ">

                <a [routerLink]="" (click)="ViewPdf(pdflist.filePathEn)">

                  {{pdflist.docTitleEn}}&nbsp;<i *ngIf="pdflist.docType ==='pdf'" class="pdf-icon"
                    aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType ==='xls' || pdflist.docType ==='xlsx' || pdflist.docType ==='xlsb'"
                    class="xls-icon" aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType ==='link'" class="external-link" aria-hidden="true"></i> </a>

              </span>

              <span
                *ngIf="usefulLink.id === pdflist.content?.id && (pdflist.filePathHi === '' || pdflist.filePathHi === null)  &&  pdflist.docTitleHi!=null ">

                {{pdflist.docTitleHi}}&nbsp;

              </span>

            </span>

          </li>





        </ul>

      </span>



    </div>



  </div>

</div>
<cbic-footer *ngIf="PdfDataList.length !==0"></cbic-footer>